// src/plugins/captcha.js

function getToken() {
  return new Promise((resolve, reject) => {
    const captcha = new window.TencentCaptcha(
     '199728599',
      function (res) {
        if (res.ret === 0) {
          resolve({
            ticket: res.ticket,
            randstr: res.randstr
          });
        } else {
          reject('captcha failed');
        }
      },
      { loading: false }
    );

    captcha.show();
  });
}

export default {
  install(Vue) {
    Vue.prototype.$captcha = getToken;
  }
};
